// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import SheetLayout from "./sheet-layout.js"
import SheetSize from "./sheet-size.js"
import Supplier from "./supplier.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_size_id": {
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_size_id",
      "selected_by_default": null,
      "translated": null
    },
    "supplier_id": {
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": false,
        "type": "uuid"
      },
      "name": "supplier_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SupplierSupportedSheet",
  "collectionKey": "supplier_supported_sheets",
  "collectionName": "supplier_supported_sheets",
  "i18nKey": "supplier_supported_sheet",
  "camelizedLower": "supplierSupportedSheet",
  "name": "SupplierSupportedSheet",
  "nameDasherized": "supplier-supported-sheet",
  "pluralName": "supplier_supported_sheets",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "sheet_layout_id",
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_size_id",
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "supplier_id",
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "supplier_supported_sheet",
  "primaryKey": "id"
}

/** Frontend model for SupplierSupportedSheet. */
export default class SupplierSupportedSheet extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutId() {
    return this.readAttributeUnderscore("sheet_layout_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutId() {
    const value = this.sheetLayoutId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetSizeId() {
    return this.readAttributeUnderscore("sheet_size_id")
  }

  /** @returns {boolean} */
  hasSheetSizeId() {
    const value = this.sheetSizeId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  supplierId() {
    return this.readAttributeUnderscore("supplier_id")
  }

  /** @returns {boolean} */
  hasSupplierId() {
    const value = this.supplierId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {import("./sheet-layout.js").default | null} */
  sheetLayout() {
    return this._readBelongsToReflection({modelClass: SheetLayout, reflectionName: "sheet_layout"})
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  loadSheetLayout() {
    if (!("sheetLayoutId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutId")

    const id = this.sheetLayoutId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout",
        model: this,
        modelClass: SheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  ensureSheetLayoutLoaded() {
    return this.ensureAssociationLoaded("sheet_layout")
  }

  /** @returns {import("./sheet-size.js").default | null} */
  sheetSize() {
    return this._readBelongsToReflection({modelClass: SheetSize, reflectionName: "sheet_size"})
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  loadSheetSize() {
    if (!("sheetSizeId" in this)) throw new Error("Foreign key method wasn't defined: sheetSizeId")

    const id = this.sheetSizeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_size",
        model: this,
        modelClass: SheetSize
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  ensureSheetSizeLoaded() {
    return this.ensureAssociationLoaded("sheet_size")
  }

  /** @returns {import("./supplier.js").default | null} */
  supplier() {
    return this._readBelongsToReflection({modelClass: Supplier, reflectionName: "supplier"})
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  loadSupplier() {
    if (!("supplierId" in this)) throw new Error("Foreign key method wasn't defined: supplierId")

    const id = this.supplierId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "supplier",
        model: this,
        modelClass: Supplier
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  ensureSupplierLoaded() {
    return this.ensureAssociationLoaded("supplier")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
